import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

interface DataElement {
  data_element: string;
}

@Injectable({ providedIn: 'root' })
export class DataElementService {
  [x: string]: any;
  /**
   * Service to manage and share data elements (SubProduct[]) across components.
   */
  private dataElementsSubject = new BehaviorSubject<DataElement[]>([]);
  dataElements$ = this.dataElementsSubject.asObservable();

  setDataElements(list: DataElement[]) {
    this.dataElementsSubject.next(list);
  }

  getCurrentDataElements(): DataElement[] {
    return this.dataElementsSubject.getValue();
  }

  /**
   * BehaviorSubject to manage and share the list of all documents across components.
   */
  private browerDetails = new BehaviorSubject<any[]>([]);
  browerDetails$ = this.browerDetails.asObservable();

  setDocumnetList(list: any[]) {
    this.browerDetails.next(list);
  }

  private basicRequestParams = new BehaviorSubject<any>({});
  basicRequestParams$ = this.basicRequestParams.asObservable();

  setBasicRequestParams(list: {}) {
    this.basicRequestParams.next(list);
  }

  private instructionName = new BehaviorSubject<string>('');
  instructionName$ = this.instructionName.asObservable();

  setinstructionName(_instName: string) {
    this.instructionName.next(_instName);
  }

  private SearchDataElements = new BehaviorSubject<string>('');
  SearchDataElements$ = this.SearchDataElements.asObservable();

  setSearchDataElements(searchText: string) {
    this.SearchDataElements.next(searchText);
  }

  private assetModal = new BehaviorSubject<{ title: string; isOpen: boolean }>({ title: '', isOpen: false });
  assetModal$ = this.assetModal.asObservable();

  setAssetModalState(state: { title: string; isOpen: boolean }) {
    this.assetModal.next(state);
  }
}
